import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

import Circles from './circles'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
  },
  background: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: -1,
  },
})

export interface Props extends ViewProps {}
const PageEmpty = (props: Props) => {
  const { style, children, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.background}>
        <Circles />
      </View>
      {children}
    </View>
  )
}

export default PageEmpty
